	$('.carousel').carousel({
	  interval: 5000,
   	  pause: "false"
	});
	$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
});	
$('.clos').click(function(){
$('.headerTop').css("display", "none");
});	      
});	



$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 30) {
        $(".header_sec").addClass("fixed");
    } else {
        $(".header_sec").removeClass("fixed");
    }
});

$(document).ready(function() {
var owl = $('.cosmicSec .owl-carousel');
  owl.owlCarousel({
    margin:30,
    dots: false,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	autoHeight:true,
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 1
      },
      576: {	
      	margin:10,	
        items: 2
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});







$(document).ready(function() {
var owl = $('.starSec .owl-carousel');
  owl.owlCarousel({
    margin:30,
    dots: true,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    stagePadding: 190,
    responsive: {
      0: {	
      	stagePadding: 0,
      	margin:10,
        items: 1
      },
      481: {
      	stagePadding: 50,	
      	margin:10,	
        items: 1
      },
      576: {
      	stagePadding: 60,	
      	margin:10,	
        items: 1
      },
      768: {
      	stagePadding: 100,
      	margin:10,
        items: 2
      },         
      992: {
      	stagePadding: 100,
      	margin:20,
        items: 2
      },
      1200: {
        items: 2,
        margin:15,
      },
      1300: {
        items: 2,
        margin:25,
      },
      1600: {
        items: 2
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.deliSec .owl-carousel');
  owl.owlCarousel({
    margin:30,
    dots: false,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    autoplayTimeout: 6000, // Speed of autoplay (default: 5000)
    autoplaySpeed: 1000,   // Animation speed between slides
    smartSpeed: 1000,      // Smooth speed for transitions
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 2
      },
      576: {	
      	margin:10,	
        items: 2
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
      	margin:25,
        items: 3
      }
    }
  });
});






$(document).ready(function() {
var owl = $('.diveCaro');
  owl.owlCarousel({
    margin:30,
    dots: false,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 2
      },
      576: {	
      	margin:10,	
        items: 2
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.blaTab');
  owl.owlCarousel({
    margin:10,
    dots: false,
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: false,
    stagePadding: 40,
    responsive: {
      0: {	
      	stagePadding: 0,
        items: 2
      },
      481: {	
      	stagePadding: 0,
        items: 2
      },
      576: {		
        items: 3
      },
      768: {
        items: 4
      },         
      992: {
        items: 5
      },
      1200: {
        items: 5
      }
    }
  });
});





$(document).ready(function() {   
$('.blaTab .owl-stage .owl-item:first-child').addClass('actv');	 
$(".blastSec .blaBtn").click(function(event) {        
	event.preventDefault();        
	$(this).parent().parent().addClass("actv");        
	$(this).parent().parent().siblings().removeClass("actv");        
	var tab = $(this).attr("href");        
	$(".blaTabDet").not(tab).css("display", "none");    
	$(tab).fadeIn();    
	});
});

$(document).ready(function() {    
$(".szLst li a").click(function(event) {        
	event.preventDefault();        
	$(this).parent().addClass("actv");        
	$(this).parent().siblings().removeClass("actv");        
	var tab = $(this).attr("href");        
	$(".blaTabDet").not(tab).css("display", "none");    
	$(tab).fadeIn();    
	});
$('#ounId').click(function(){
$('.detailsvre').addClass('showourd');
$('.bundler-target-element-volume-discounts').removeClass('showourd'); 
$('#ourd').addClass('showourd');
$('#psiz').removeClass('showourd');   
});	
$('#packId').click(function(){
$('.bundler-target-element-volume-discounts').addClass('showourd');
$('.detailsvre').removeClass('showourd');  
$('#ourd').removeClass('showourd');  
$('#psiz').addClass('showourd');  
});	
  
});

$(document).ready(function() {
var owl = $('.recentSec .owl-carousel');
  owl.owlCarousel({
    margin:30,
    dots: false,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 1
      },
      576: {	
      	margin:10,	
        items: 1
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 2
      },
      1200: {
        items: 2
      }
    }
  });
});

jQuery(document).ready(function() {
    jQuery('.logocaro.owl-carousel').owlCarousel({
    loop: true,
    //navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
    items: 6,
    autoplay: true,
    //slideTransition: 'linear',
    autoplaySpeed: 1000,
    smartSpeed: 1000,
    dots: false,
    nav: false,
    responsive: {
    	1: {	
        items: 2
      },
      440: {	
        items: 3
      },
      768: {
        items: 4
      },         
      992: {
        items: 4
      },
      1200: {
        items: 6
      }	
    	
    }
    });


   jQuery('.logocaro.owl-carousel').trigger('play.owl.autoplay',[1000]);

   function setSpeed(){
       jQuery('.logocaro.owl-carousel').trigger('play.owl.autoplay',[1000]);
   }

   setTimeout(setSpeed, 2000);
});





































